import { Styles } from 'common/lib/material-ui/theme';

export const initViewContainer: Styles = {
  display: 'flex',
  alignItems: 'center',
  flexDirection: 'column',
  px: { mobile: 3.75, desktop: 7 },
};
